/*
	When it is called on page initialization, after the user presses the 
	'Enter' key, it will trigger the button with: id="submit".
*/

export const submitOnPressEnter = () => {
	let isEnabled = true

	// If the user is typing inside a textarea element, we prevent
	// the submit to work with 'Enter' button (because it is used as break line on textarea)
	document.addEventListener('click', (event) => {
		if (event.target.tagName === "TEXTAREA") {
			isEnabled = false
		} else {
			isEnabled = true
		}
	})

	document.addEventListener('keypress', ({ key }) => {
		if (key === 'Enter' && document.getElementById("submit") && isEnabled) {
			document.getElementById("submit").click();
		}
	})
};